module.exports = __webpack_public_path__ + "static/media/smarttech.1fca64c1.png";